import PageTitle from '../components/PageTitle'
import SEO from '../components/SEO'
import './About.css'

export default function About() {
  return (
    <main className="bg-white">
      <SEO 
        title="회사 소개"
        description="씨피엔터테인먼트(CP Entertainment)는 쿠팡의 자회사로, 아티스트 매니지먼트와 콘텐츠 제작을 전문으로 하는 엔터테인먼트 기업입니다. SNL 코리아, 직장인들 등 제작."
        path="/about"
        keywords="cpent 회사 소개, 씨피엔터테인먼트 소개, CP Entertainment about, 쿠팡 자회사, 쿠팡엔터테인먼트, cpentertainment, 엔터테인먼트 기업"
      />
      {/* Page Title */}
      <PageTitle title="About Us" />
      
      {/* Description Section */}
      <section className="about-description">
        <div className="about-description-wrapper">
          <article className="about-description-content">
            <div className="about-description-text">
              <span className="about-description-dash" aria-hidden="true">-</span>
              <p className="about-description-paragraph">
                씨피엔터테인먼트(CP Entertainment)는 쿠팡의 자회사로, 아티스트 매니지먼트와 콘텐츠 제작을 전문으로 하는 엔터테인먼트 기업입니다. 
                <br /><br />
                매니지먼트 부문에서는 아티스트의 성장과 활동을 위한 전방위 지원을 제공합니다. 신인 발굴부터 브랜드 구축, 홍보 전략, 마케팅 실행까지 각 단계별로 전문 인력이 체계적으로 관리하며, 아티스트가 지속적으로 활동 영역을 확장할 수 있도록 돕습니다. 
                <br /><br />
                제작 부문에서는 창작자가 아이디어를 실제 콘텐츠로 구현할 수 있도록 제작 환경과 인프라를 제공합니다. 이를 통해 &lt;SNL 코리아&gt;, &lt;직장인들&gt; 등 다양한 예능 콘텐츠를 선보이며, 시청자에게 새로운 재미와 몰입감을 전달하고 있습니다.
              </p>
            </div>
          </article>
        </div>
      </section>

      {/* Press Release Section - Hidden */}
      {/* <section className="about-press-release">
        <div className="about-press-release-wrapper">
          <div className="about-press-release-content">
            <a
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              className="about-press-release-link"
            >
              보도자료 보러가기 &gt;
            </a>
          </div>
        </div>
      </section> */}
    </main>
  )
}
